import { configureStore } from "@reduxjs/toolkit";
import { medicalPlanMappingsApi } from "Features/MedicalPlanMappings/medicalPlanMappings.api";
import { planSuitesApi } from "Features/PlanSuites/planSuites.api";

import { abTestReducer } from "Common/abTestUtils/redux";
import { siteConfigSlice } from "Common/Redux/siteConfig";

export const reducerSlices = {
  abTests: abTestReducer,
  [medicalPlanMappingsApi.reducerPath]: medicalPlanMappingsApi.reducer,
  [planSuitesApi.reducerPath]: planSuitesApi.reducer,
  [siteConfigSlice.name]: siteConfigSlice.reducer,
};

export const createStore = (preloadedState) => {
  const store = configureStore({
    reducer: reducerSlices,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(planSuitesApi.middleware, medicalPlanMappingsApi.middleware),
    preloadedState,
  });

  return store;
};
